(function () {
  function initIconReveal() {
    var triggers = document.querySelectorAll('[data-reveal-target]');
    if (!triggers.length) return;

    triggers.forEach(function (trigger) {
      if (trigger.dataset.revealInit) return;
      trigger.dataset.revealInit = '1';

      var targetId = trigger.getAttribute('data-reveal-target');
      var target = targetId ? document.getElementById(targetId) : null;
      if (!target) return;

      trigger.addEventListener('click', function () {
        var isHidden = window.getComputedStyle(target).display === 'none';

        triggers.forEach(function (other) {
          if (other === trigger) return;
          var otherId = other.getAttribute('data-reveal-target');
          var otherTarget = otherId ? document.getElementById(otherId) : null;
          if (otherTarget) otherTarget.style.removeProperty('display');
          other.setAttribute('aria-expanded', 'false');
        });

        if (isHidden) {
          target.style.setProperty('display', 'block', 'important');
          trigger.setAttribute('aria-expanded', 'true');
          setTimeout(function () {
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }, 50);
        } else {
          target.style.removeProperty('display');
          trigger.setAttribute('aria-expanded', 'false');
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initIconReveal);
  } else {
    initIconReveal();
  }

  document.addEventListener('shopify:section:load', initIconReveal);
})();
